<template>
  <el-table :data="logData" border size="mini" :resizable="false">
    <el-table-column label="时间" width="140">
      <template slot-scope="scope">
        {{ scope.row.createdAt | formatTime }}
      </template>
    </el-table-column>
    <el-table-column label="操作" prop="operation" width="60"> </el-table-column>
    <el-table-column label="用户" prop="user" width="100"> </el-table-column>
    <el-table-column label="修改内容">
      <template slot-scope="scope">
        {{ scope.row.updatedFields | formatUpdatedFields }}
      </template>
    </el-table-column>
    <el-table-column label="fullDocument">
      <template slot-scope="scope">
        <span v-if="scope.row.fullDocument"> {{ JSON.stringify(scope.row.fullDocument) }} </span>
        <el-button v-else type="text" size="mini" @click="showFullDocument(scope.row)">查看</el-button>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
const dateFormat = require('dateformat')
export default {
  props: {
    id: String,
    type: String,
  },
  filters: {
    formatTime: function(time) {
      return dateFormat(new Date(time), 'yyyy-mm-dd HH:MM:ss')
    },
    formatUpdatedFields: function(fields) {
      if (!fields) {
        return '无'
      }
      delete fields.__requestId
      delete fields.__requestSender
      if (Object.keys(fields).length === 0) {
        return '无'
      }
      return JSON.stringify(fields)
    },
  },
  data: function() {
    return {
      logData: [],
    }
  },
  methods: {
    loadData: async function() {
      const res = await app.service('misc').listLogs({ type: this.type, _id: this.id })
      if (res.status === 'success') {
        this.logData = res.data
      } else {
        this.$message.error(res.msg)
      }
    },
    showFullDocument: async function(row) {
      if (!row.fullDocument) {
        const res = await app.service('misc').fetchLog({ type: this.type, _id: row._id })
        if (res.status === 'success') {
          // row = res.data
          delete res.data.fullDocument.similarity
          this.logData = this.logData.map(log => {
            if (log._id === row._id) {
              log = res.data
            }
            return log
          })
        } else {
          this.$message.error(res.msg)
        }
      }
    },
  },
  mounted() {
    this.loadData()
  },
}
</script>
